import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, Tab, Tabs } from "@mui/material";
import { Form, Formik } from "formik";
import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import InitialObjectStructures from "../../FormModel/InitialObjectStructure.json";
import validationSchema from "../../FormModel/validationSchema";
import {
  DELETECANCEL,
  NOMINEE_1,
  NOMINEE_2,
  OKCANCEL,
} from "../../Utils/GlobalValues";
import AlertModal from "../CsplModal/AlertModal";
import AddNominee from "../Widgets/NominationDetail/AddNominee";
import DeleteNominee from "../Widgets/NominationDetail/DeleteNominee";
import styles from "../Widgets/NominationDetail/NominationDetail.module.css";
import NomineeDetail from "../Widgets/NominationDetail/NomineeDetail";
import OptionalNomineeDetail from "../Widgets/NominationDetail/OptionalNominee";
import NomineeDetailJson from "../Widgets/NominationDetail/NominationDetails.json";
import { FormikPatchTouched } from "../../Utils/FormikPatchTouched";

//TabPanel Component for display that corresponding tab's content
function TabPanel(props) {
  const { children, value, index } = props;

  return <>{value === index && <>{children}</>}</>;
}

function NomineeDetailsForm(props) {
  const { t } = useTranslation("common");
  const applicationContext = useContext(KycApplicationContext);
  const [currentValidationSchema, setCurrentValidationSchema] = useState({});
  const [formValidationSchema, setFormValidationSchema] = useState({});
  const [initialObjectStructure, setInitialObjectStructure] = useState({});
  const [value, setValue] = useState(0);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isSecondNomineePresent, setIsSecondNomineePresent] = useState(false);
  let isDisabled = applicationContext.disableForm;
  
  // get the form validation schema based on the current widget
  function getFormValidationSchema(currentWidget) {
    return _.find(
      validationSchema,
      (obj) => obj.widgetShortName == currentWidget
    );
  }

  function createValidationSchema(inputObj, subObj, mainObj) {
    var temp = Yup.object({
      [mainObj]: Yup.object().shape({
        [subObj]: inputObj,
      }),
    });
    return temp;
  }

  useEffect(() => {
    if (
      formValidationSchema != null &&
      formValidationSchema != undefined &&
      formValidationSchema.validationSchemaObj != null &&
      formValidationSchema.validationSchemaObj != undefined &&
      value != null &&
      value != undefined
    ) {
      let currentTabValidation = NomineeDetailJson.nominee1;
      if (value == 1) {
        currentTabValidation = NomineeDetailJson.nominee2;
        setCurrentValidationSchema(
          ()=>{
            var schema=  Yup.object({
             "nomineeWidgetDTO": formValidationSchema.validationSchemaObj.fields.nomineeWidgetDTO
            })
            return schema;
          }
         
        );

      }else{
        setCurrentValidationSchema(
          createValidationSchema(
            formValidationSchema.validationSchemaObj.fields.nomineeWidgetDTO
              .fields[currentTabValidation],
            currentTabValidation,
            NomineeDetailJson.object
          )
        );
      }
      // set the validation schema based on the tab index
     
    }
  }, [value, formValidationSchema]);

  useEffect(() => {
    if (
      applicationContext.currentWidget != null &&
      applicationContext.currentWidget != undefined
    ) {
      const currentWidget = applicationContext.currentWidget.widgetShortName;

      //set the form validation schema
      setFormValidationSchema(getFormValidationSchema(currentWidget));

      //set the initial object structure
      setInitialObjectStructure(InitialObjectStructures);
    }
  }, [applicationContext.currentWidget]);

  // check if the index is last index
  function isLastIndex() {
    if (props.value.nomineeWidgetDTO.nomineeCount === 2) {
      if (value == 0) {
        return false;
      }
    }
    return true;
  }

  // handle submit
    function _handleSubmit(values, actions) {
      if (isLastIndex()) {
        props.onSubmit(
          values).then(
            (res) => {
              // operations to be dont on submit to avoid issues
              actions.setTouched({});
              actions.setSubmitting(false);
            },
            (error) => {
              actions.setSubmitting(false);
            }
          );
           
      } else {
        props.onNext(
          values,getCurrentTabName()).then(
            (res) => {
              // set the current tab index
              setValue(value + 1);
              // operations to be dont on submit to avoid issues
              actions.setTouched({});
              actions.setSubmitting(false);
            },
            (error) => {
              actions.setSubmitting(false);
            }
          )
        
      }
    }
/**
   * get Current Tab name
   * @returns String
   */
 function getCurrentTabName(){
   if(value===0){
     return NOMINEE_1;
   }else if(value===1){
    return NOMINEE_2;
   }
 }

  // set the nominee count as 2 and set initial object structure for nominee 2
  function addOptionalNominee(values) {
    
    //let tempValue = props.value;
    values.nomineeWidgetDTO.nomineeCount = 2;
    values.nomineeWidgetDTO.nomineeCount = 2;
    values.nomineeWidgetDTO.nominee2 = {};
    values.nomineeWidgetDTO.nominee2 = initialObjectStructure[NomineeDetailJson.object].nominee1;
    values.nomineeWidgetDTO.nominee2.sharePercentage = 50;
    values.nomineeWidgetDTO.nominee1.sharePercentage = 50;
    values.nomineeWidgetDTO.nominee2.nomineeCount = 2;

    props.onSaveToStore(values);
    setValue(1);
  }

  //add Optional Nominee
  const onAddSecondNominee = (data) => {
    setIsSecondNomineePresent(true);
    // set the nominee count as 2 and set initial object structure for nominee 2
    addOptionalNominee(data);
  };

  //add Optional Nominee
  const addSecondNominee = (e) => {
    e.preventDefault();
    setIsAddModalOpen(true);
  };

  function removeOptionalNominee(formikObj) {
    //let tempValue = props.value;
    let values = formikObj.values;
    values.nomineeWidgetDTO.nomineeCount = 1;
    values.nomineeWidgetDTO.nominee2 = null;
    values.nomineeWidgetDTO.nominee1.sharePercentage = 100;
    //clear the field errors
    formikObj.setFieldTouched("nomineeWidgetDTO.nominee2","")

    props.onSaveToStore(values);
    setValue(0);
  }

  const onDeleteNominee = (formikObj) => {
    setIsSecondNomineePresent(false);
    // set the nominee count as 1 and set the initial object structure as null
    removeOptionalNominee(formikObj);
  };

  //Remove Optional Nominee
  const removeSecondNominee = (e) => {
    e.preventDefault();
    setIsDeleteModalOpen(true);
  };

  // maintain the current Tab object
  const isActive = (selectedtab) => {
    return (
      " tab_panel_button " +
      (value !== null && value !== undefined && value === selectedtab
        ? "tabactive"
        : "tab_panel_button")
    );
  };

  // assign  selected tab
  const assignTab = (e, obj) => {
    e.preventDefault();

    if (obj === NOMINEE_1) {
      setValue(0);
    } else {
      setValue(1);
    }
  };

  // tasks to be performed on clicking the back button
  function _handleBack(event, values) {
    event.preventDefault();
    //if present in the first tab the call on bank and move to previous widget
    if(value === 0 ){
       props.onBack(values);       
    }else{
      setValue(value - 1);
    }
    
  }

  useEffect(() => {
    if (props.value.nomineeWidgetDTO.nomineeCount === 2) {
      setIsSecondNomineePresent(true);
    }

  }, []);

  const [initialValue, setInitialValue] = useState(props.value || initialObjectStructure);


  return (
    <>
      <Formik
        initialValues={initialValue} 
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
        enableReinitialize={true}
        noValidate={true}
      >
        {(formikObj) => (
          <Form id={value} autoComplete="off" noValidate={true}>
          <FormikPatchTouched/>
            <Box>
              <Tabs
                variant="scrollable"
                value={value}
                scrollButtons="auto"
                allowScrollButtonsMobile
                className="tab_panel"
              >
                <Tab
                  label={t("nominee.nominee1")}
                  id="tab_panel_button"
                  onClick={(event) => assignTab(event, NOMINEE_1)}
                  value={0}
                  className={isActive(0)}
                ></Tab>
                {isSecondNomineePresent && (
                  <Tab
                    value={1}
                    label={t("nominee.nominee2")}
                    id="tab_panel_button"
                    onClick={(event) => assignTab(event, NOMINEE_2)}
                    icon={!isDisabled &&
                      <ClearIcon
                        onClick={(event) => removeSecondNominee(event)}
                      ></ClearIcon>
                    }
                    iconPosition="end"
                    className={isActive(1)}
                  ></Tab>
                )}

                {(!isSecondNomineePresent & !isDisabled) && (
                  <Button
                    value={2}
                    onClick={(event) => addSecondNominee(event)}
                    className={styles.addNominee}
                  >
                    <span className="round_plus me-1" /> 
                     <span> Nominee </span> 
                  </Button>
                )}
              </Tabs>

              {isDeleteModalOpen && (
                <AlertModal
                  isModalOpen={isDeleteModalOpen}
                  setIsModalOpen={setIsDeleteModalOpen}
                  businessProcess={onDeleteNominee}
                  title={"nominee.deleteTitle"}
                  type={DELETECANCEL}
                  data={formikObj}
                >
                  <DeleteNominee />
                </AlertModal>
              )}

              {isAddModalOpen && (
                <AlertModal
                  isModalOpen={isAddModalOpen}
                  setIsModalOpen={setIsAddModalOpen}
                  businessProcess={onAddSecondNominee}
                  title={"nominee.addTitle"}
                  data={formikObj.values}
                  type={OKCANCEL}
                >
                  <AddNominee />
                </AlertModal>
              )}
              <TabPanel value={value} index={0}>
                <NomineeDetail />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <OptionalNomineeDetail />
              </TabPanel>
            </Box>

            {formikObj.errors && console.log(formikObj.errors)}
            {formikObj && props.onChange(formikObj.values)} 
            
            {/* When ever form data changes then raise on change props with values */}
          {/*   {props.onChange(values)}  */}
            <div className="action_bar d-flex justify-content-between py-2">
              <div>
                {(
                  <Button
                    className="btn shadow-none action_btn"
                    onClick={event=> _handleBack(event,formikObj.values)}
                  >
                    {" "}
                    {t("form.back")}{" "}
                  </Button>
                )}
              </div>
              <div>
                <Button
                  className="btn shadow-none action_btn me-2"
                  disabled={formikObj.isSubmitting}
                  type="submit"
                >
                  {" "}
                  {t("form.next")}{" "}
                </Button>               
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default NomineeDetailsForm;

